module.exports = __webpack_public_path__ + "static/media/Blossom.9c27d2a6.png";